<template>
	<div class="monitoring">
		<div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
		</div>
		<v-container fluid>
			<AlphabeticFilter :value="letter" ref="alphabeticFilter" class="mb-3" />
			<p
				v-if="Object.keys(filteredMonitoredSymptoms).length == 0"
				class="font-weight-thin ml-2"
				v-translate
			>No patients being monitored.</p>
			<v-list v-else>
				<v-list-item
					v-for="patientMonitoredSymptoms in filteredMonitoredSymptoms"
					style="border-radius: 5px; border: 1px solid #e3e3e3"
					:key="patientMonitoredSymptoms[0].patient_id"
				>
					<v-list-item-icon class="mr-3">
						<v-icon color="primary">person</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title
							style="cursor: pointer"
							@click="goToPatient(patientMonitoredSymptoms[0].patient_id)"
							class="mt-2"
						>{{patientMonitoredSymptoms[0].patient_name}}</v-list-item-title>
						<MonitoredSymptomList :monitoringTab="true" class="mt-2" :monitoredSymptoms="patientMonitoredSymptoms" @delete-monitored-symptom="deleteMonitoredSymptom"/>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-container>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import axios from "axios";
import MonitoredSymptomList from "@/components/patient/MonitoredSymptomList.vue";
import AlphabeticFilter from "@/components/AlphabeticFilter.vue";

export default {
	name: "Monitoring",
	components: {
		Breadcrumbs,
		MonitoredSymptomList,
		AlphabeticFilter
	},
	data: () => ({
		monitoredSymptoms: [],
		some: false,
		letter: "no-filter"
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Monitoring"),
					disabled: false,
					link: true,
					to: { name: "monitoring" }
				}
			];
		},
		patientsMonitoredSymptoms() {
			let patientsMonitoredSymptoms = {};
			this.monitoredSymptoms.forEach(mS => {
				let id = mS.patient_name + mS.patient_id;
				if (!patientsMonitoredSymptoms[id]) patientsMonitoredSymptoms[id] = [];
				patientsMonitoredSymptoms[id].push(mS);
			});
			return patientsMonitoredSymptoms;
		},
		orderedMonitoredSymptoms() {
			return Object.keys(this.patientsMonitoredSymptoms).sort().reduce((r, k) => (r[k] = this.patientsMonitoredSymptoms[k], r), {});
		},
		filteredMonitoredSymptoms() {
			if (!this.$refs.alphabeticFilter || this.$refs.alphabeticFilter.getLetter() === "no-filter") {
				return this.orderedMonitoredSymptoms;
			} else {
				return Object.fromEntries(Object.entries(this.orderedMonitoredSymptoms).filter((val) =>
					val[1][0].patient_name.charAt(0).toUpperCase() === this.$refs.alphabeticFilter.getLetter().toUpperCase()
				));
			}
		},
	},
	methods: {
		goToPatient(patientId) {
			this.$router.push({
				name: "patient",
				params: { pid: patientId, tab: "monitoring" }
			});
		},
		deleteMonitoredSymptom(mS) {
			this.monitoredSymptoms.splice(this.monitoredSymptoms.indexOf(mS), 1);
		}
	},
	created() {
		axios
			.get("/monitored_symptoms")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
					this.monitoredSymptoms = response.data.monitored_symptoms;
				}
			})
			.catch(error => console.log(error));
	}
};
</script>